const common = {
    no_data: '데이터가 없습니다',
    header: {
        business_name: '귀하의 비즈니스'
    },
    download_app: {
        text: 'Simply 웹 버전을 사용하려면 노트북이나 PC를 사용하세요.',
        button: '모바일 버전 다운로드'
    },
    unknown: '알 수 없음',
    request_error: '오류가 발생했습니다. 다시 시도하세요! 문제가 계속되면 고객 지원에 문의하세요.',
    home: '홈',
    dashboard: '대시보드',
    product: '제품',
    add_product: '제품 추가',
    edit_product: '제품 편집',
    stock_in: '입고',
    Sales_Turnover: '매출액',
    profit: '이익',
    stock_out: '출고',
    staff: '직원',
    stock_audit: '재고 감사',
    button: {
        save: '저장',
        save_and_add_more: '저장 후 추가',
        submit: '제출',
        done: '완료',
        edit: '편집',
        save_edit: '변경 사항 저장',
        yes: '예',
        clear: '지우기',
        delete: '삭제',
        cancel: '취소',
        reset: '재설정'
    },
    select_date: '날짜 선택',
    select_action: '작업 선택',
    mandatory: ' *(필수)',
    not_mandatory: '(선택 사항)',
    business: '비즈니스',
    account: '계정',
    profile: '프로필',
    setting: '설정',
    whichLanguage: '한국어',
    headerDashboard: 'VIP 되기',
    contact_us: '문의하기',
    logout: '로그아웃',
    category: '카테고리',
    add_category: '카테고리 추가',
    data: '데이터',
    history: '히스토리',
    lowStockAlert: '재고 부족 알림',
    Expenses: '비용',
    lowStockAlertButton: '안전 재고 수량 추가',
    message: {
        login_success: '성공적으로 로그인되었습니다!',
        onboard_success: '축하합니다!! 여정이 시작되었습니다!',
        successfully_saved: '데이터가 성공적으로 저장되었습니다',
        successfully_deleted: '데이터가 성공적으로 삭제되었습니다',
        error_required_field: '필수 입력란을 비워둘 수 없습니다',
        no_access: '접근 권한이 없습니다',
        no_permission: '권한이 없습니다',
        error_update_history: '히스토리 업데이트 실패'
    },
    no_permission_dialog: {
        title: '권한이 없습니다',
        description: '지출을 볼 권한이 없습니다. 관리자에게 문의하세요.'
    },
    feedback: '피드백 제공',
    contact: '연락처',
    add: '추가',
    supplier: '공급업체',
    customer: '고객',
    random: '무작위',
    scan: '스캔',
    enter: '바코드 스캔으로 로그인',
    terms: {
        text: '계속 진행하면 다음에 동의하는 것으로 간주됩니다',
        link: '개인정보 처리방침'
    },
    others: '기타',
    calender: {
        presets: {
            today: '오늘',
            yesterday: '어제',
            last_7_days: '지난 7일',
            last_30_days: '지난 30일',
            this_month: '이번 달',
            last_month: '지난달',
            custom_range: '사용자 지정 범위'
        }
    },
    print_large: '대형 인쇄 (A4)',
    print_letter: '레터 인쇄 (US)',
    print_dot_matrix: '대형 인쇄 (도트 매트릭스)',
    print_medium: '중간 인쇄 (75mm)',
    print_small: '소형 인쇄 (48mm)',
    format: '용지 형식',
    preview: '미리보기',
    view_invoice: '송장',
    view_chalan: '출하장',
    price: '가격',
    stock: '재고',
    quantity: '수량',
    total: '총계',
    print_footer_left: '제작자',
    print_footer_center: '출력일',
    print_footer_date: '날짜',
    print_to: '수신자',
    language: '한국어',
    dateStatus: '지난 7일',
    placeholder: '거래 유형',
    staffHistory: '직원 선택',
    languageTitle: '한국어',
    date: '날짜',
    download: '다운로드',
    download_excel: '엑셀 다운로드',
    download_pdf: '바코드 다운로드',
    currentTitle: '통화',
    Selectperiod: '기간 선택',
    TransactionType: '거래 유형',
    SelectCustomer: '고객 선택',
    invoice: '송장',
    login: {
        google: 'Google로 로그인',
        apple: 'Apple로 로그인'
    },
    trusted_by: {
        title: '인도네시아 🇮🇩 전역에서 50,000개 이상의 기업이 신뢰합니다'
    },
    privacyPolicyOne: "로그인함으로써 Simply의",
    privacyPolicyTwo: '개인정보 처리방침',
    manufacture: '제조업체',
    warehouse: '창고',
    error: {
        title: '이런! 문제가 발생했습니다',
        description: '예기치 않은 오류가 발생했습니다. 페이지를 새로고침하거나 홈으로 돌아가 보세요.',
        refresh: '페이지 새로고침',
        go_back: '홈으로 돌아가기',
        not_found: '페이지를 찾을 수 없습니다'
    },
    totalPurchasePrice: '총 구매 가격',
    pageTotalPurchaseAmount: '페이지 총 구매 금액',
    approval_status: '승인 상태',
    pending: '대기 중',
    approved: '승인됨',
    rejected: '거절됨',
    select_fields: '필드 선택',
    syncWithTally: 'Tally와 동기화',
    importFromTally: 'Tally에서 가져오기',
    exportToTally: 'Tally로 내보내기',
    All: '모두',
    Approval: '승인'
}

export default common;
